import { Component, inject } from '@angular/core';
import { PersonCategoryService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  PersonCategoryCreateDto,
  PersonCategoryDto,
  PersonCategoryExcelDownloadDto,
  PersonCategoryUpdateDto,
} from '../proxy/general/dtos/person-category';
import { PERSONCATEGORY_CONFIG, PERSONCATEGORY_FIELDS } from './person-category.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-person-category',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, PersonCategoryService, ConfirmationService],
  templateUrl: './person-category.html',
  styleUrl: './person-category.scss',
})
export class PersonCategory extends BaseCrudComponent<
  PersonCategoryDto,
  PersonCategoryCreateDto,
  PersonCategoryUpdateDto,
  PersonCategoryExcelDownloadDto
> {
  service = inject(PersonCategoryService);
  config = PERSONCATEGORY_CONFIG;
  fields = PERSONCATEGORY_FIELDS;

  protected prepareUpdateDto(data: any, selected: PersonCategoryDto): PersonCategoryUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'PersonCategory';
  }
}
